import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ProjectList from '../../components/Attendance/monthlyAttendance'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_projectMonthlyAttendance } from '../../actions/v3/attendance'
import moment from 'moment'
import ExportColumnModal from '../../components/common/ExportColumnModal'
import { exportRowsToExcel } from '../../utils'
const List = (props) => {


    const location = useLocation();
    const { project } = location.state || {};
    const [data, setData] = useState([])

    const attendanceExportColumns = [
        { key: 'serialNo', label: 'S/No', value: (row, index) => index + 1 },
        { key: 'name', label: 'Name', value: (row) => row.FULL_NAME },
        { key: 'date', label: 'Date', value: (row) => moment(row.DATE).format("DD-MMM-YY") },
        { key: 'dateAttribute', label: 'Date Attribute', value: (row) => row.DATE_ATTRIBUTE },
        { key: 'from', label: 'From', value: (row) => row.TIME_FROM || "" },
        { key: 'to', label: 'To', value: (row) => row.TIME_TO || "" },
        { key: 'actualAttendance', label: 'Actual Attendance', value: (row) => row.ACTUAL_ATTENDANCE || "" },
        { key: 'ot', label: 'OT', value: (row) => row.OT || "" },
        { key: 'remark', label: 'Remark', value: (row) => row.REMARK || "" },
    ];

    const exportToExcel = (selectedColumns = attendanceExportColumns) => {
        // File name with project + month
        const formattedMonth = month
            ? moment(month, "YYYY-MM").format("MMM-YYYY")
            : moment().format("MMM-YYYY");

        const fileName = `${project?.PROJECT_NAME || "Project"
            }_Timesheet_${formattedMonth}.xlsx`;

        exportRowsToExcel({
            rows: data,
            columns: selectedColumns,
            sheetName: "Attendance",
            fileName,
        });
    };
    const [month, setMonth] = useState(moment().format('YYYY-MM'))
    useEffect(() => {
        v3_projectMonthlyAttendance(project.PROJECT_ID, moment(month).format('MM'), moment(month).format('YYYY')).then((res) => {
            if (res.status) {
                setData(res.result.rows);
                props.history.push(constant.Authedcomponent.attendanceMonthlyReport.url, {
                    project
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [month])

    return (
        <Layout
            title={`Monthly Attendance | ${project.PROJECT_NAME}`}
        >

            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Attendance Sheet</h4>
                <div className="d-flex align-items-center gap-2">
                    <input
                        type="month"
                        className="form-control"
                        style={{ width: "200px" }}
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                    />
                    <button
                        className="btn btn-success"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance-export-columns-modal"
                    >
                        Export to Excel
                    </button>
                </div>
            </div>

            {data && <ProjectList
                rows={data}
                project={project}
                month={moment(month).format('MM')}
                year={moment(month).format('YYYY')}
            />}
            <ExportColumnModal
                modalId="attendance-export-columns-modal"
                title="Select Attendance Columns"
                columns={attendanceExportColumns}
                onExport={exportToExcel}
            />
        </Layout>
    )
}

export default List
